import { render, staticRenderFns } from "./qycgdetails.vue?vue&type=template&id=14d1ec48&"
import script from "./qycgdetails.vue?vue&type=script&lang=js&"
export * from "./qycgdetails.vue?vue&type=script&lang=js&"
import style0 from "./qycgdetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports